import { ref } from 'vue';

interface TooltipManagerOptions {
	delay?: number;
	displayDuration?: number;
	maxRepeatCount?: number;
}

let campaignId: number | null = null;
const tooltipShowCount = ref(0);

export function useTooltipManager(options: TooltipManagerOptions = {}) {
	const { delay = 5000, displayDuration = 3000, maxRepeatCount = 3 } = options;

	const showTooltip = ref(false);
	let tooltipTimer: any;

	//let campaignId: number | null = null;
	const pause = () => {
		if (tooltipTimer) {
			clearTimeout(tooltipTimer);
			tooltipTimer = null;
		}
		showTooltip.value = false;
	};

	const stop = () => {
		pause();
		//campaignId = null;
		setTooltipShowCount(maxRepeatCount);
	};

	const setTooltipShowCount = (count: number) => {
		tooltipShowCount.value = count;
	};

	const init = (id: number | null) => {
		pause();
		if (id == null || id === campaignId) return;
		//if (campaignId != id) {
		campaignId = id;
		setTooltipShowCount(0);
		//}
	};

	const run = () => {
		// Add initial delay before first show

		//show();

		tooltipTimer = setTimeout(() => {
			show();
		}, delay);
	};

	const show = () => {
		pause();
		if (!campaignId) {
			return;
		}

		if (tooltipShowCount.value >= maxRepeatCount) {
			return;
		}

		// Show tooltip immediately
		showTooltip.value = true;
		setTooltipShowCount(tooltipShowCount.value + 1);

		// Single timeout to handle the complete cycle
		tooltipTimer = setTimeout(() => {
			showTooltip.value = false;

			// Schedule next show if not at max count
			if (tooltipShowCount.value < maxRepeatCount) {
				tooltipTimer = setTimeout(() => {
					show();
				}, delay);
			}
		}, displayDuration);
	};

	return {
		showTooltip,
		init,
		run,
		pause,
		stop
	};
}
